import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { MunicipalityLogo, REQUEST_METHOD, authActionlogout, dataTaggerActionClearAll, memoActionDelAll, sequenceActionReset } from '@laramie/ui';
import { ServerRequest } from '../../../utils/apiweb';
import { APIS } from '../../../config/apis';

import { HeaderContext } from '../context'

import './index.css';
import { UserSubMenu } from '../Header/components';
import { ssoEnabled, ssoLogout } from '../../../utils/sso';


function HeaderBasic() {

    const dispatch = useDispatch();

    const { isAuthenticated } = useSelector(state => state.auth)

    const handleClickLogout = () => {
        const callbackSuccess = () => {
            dispatch( memoActionDelAll() );
            dispatch( dataTaggerActionClearAll() );
            dispatch( sequenceActionReset() );
            dispatch( authActionlogout() );
            // Sin esto Keycloak conserva su sesión y /login vuelve a entrar solo.
            if (ssoEnabled()) ssoLogout();
        };

        const path = '/expirate';

        ServerRequest(
            REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.SESION,
            path,
            null,
            callbackSuccess,
            callbackSuccess,
            callbackSuccess
        );
    }

    return (

        <nav className="navbar navbar-expand-sm p-top-15">

            <div className='navlogo m-left-17'>
                <MunicipalityLogo filename="LogoMunicipio.png" className="logo-img logo-default" />
                <MunicipalityLogo filename="LogoMunicipioColor.png" className="logo-img logo-color" />
            </div>

            <div className="collapse navbar-collapse">

            </div>

            <div className='collapse navbar-collapse login-nav'>
                <HeaderContext.Provider value={{ isAuthenticated, handleClickLogout }}>
                    <UserSubMenu />
                </HeaderContext.Provider>
            </div>
    
        </nav>

    )
}

export default HeaderBasic;